module.exports = __webpack_public_path__ + "static/img/featrue1.96b034ad.png";